import type { FlightIngredient } from '@apps/main/modules/recipe/ingredients';
import type { FlightIngredientFilters } from '@apps/main/modules/recipe/ingredients/flightIngredient';

import { TRANSPORT_FILTERS_SEPARATOR } from '../constants';
import {
  serializePorts,
  serializeTransportIds,
  serializeTransportFilters,
  serializeAvailabilityOrder,
} from '../serializeTransport';

import { FLIGHT_INGREDIENT_SUFFIX } from './constants';

export function serializeFlight(flight: FlightIngredient): string {
  let result = serializePorts(flight);

  result += serializeTransportIds(flight.transportIds);

  result += serializeFlightFilters(flight.filters);

  result += serializeAvailabilityOrder(flight);

  result += FLIGHT_INGREDIENT_SUFFIX;

  return result;
}

function serializeFlightFilters(filters: FlightIngredientFilters): string {
  const serializedFlightFilters: string[] = [];

  serializedFlightFilters.push(filters.maxNumberOfStops?.toString() ?? '');

  serializedFlightFilters.push(...serializeTransportFilters(filters));

  return serializedFlightFilters.join(TRANSPORT_FILTERS_SEPARATOR);
}
